import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { fetchMembershipAsOf } from '../api/membershipApi';
import type { MembershipAsOf } from '../types';
import { formatCount, formatRecordedAt, localTodayIso } from '../utils/membershipFormat';
import SetMembershipCountModal from './SetMembershipCountModal';
import UpdateMembershipModal from './UpdateMembershipModal';
import '../membership.css';

interface Props {
  apiPath: string;
  canUpdate: boolean;
  canOverride: boolean;
}

const ChurchMembershipTab: React.FC<Props> = ({ apiPath, canUpdate, canOverride }) => {
  const [asOf, setAsOf] = useState<MembershipAsOf | null>(null);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showOverride, setShowOverride] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    fetchMembershipAsOf(apiPath, localTodayIso()).then((response) => {
      if (cancelled || !response.isSuccess()) return;
      setAsOf(response.getData());
    });
    return () => {
      cancelled = true;
    };
  }, [apiPath, reloadKey]);

  return (
    <div>
      <div className="membership-tiles membership-tiles--summary membership-tiles--summary-3 mb-3">
        <div className="membership-tile">
          <div className="membership-tile__label">Total members</div>
          <div className="membership-tile__value">{formatCount(asOf?.current_total)}</div>
        </div>
        <div className="membership-tile">
          <div className="membership-tile__label">Male</div>
          <div className="membership-tile__value">{formatCount(asOf?.current_male_count)}</div>
        </div>
        <div className="membership-tile">
          <div className="membership-tile__label">Female</div>
          <div className="membership-tile__value">{formatCount(asOf?.current_female_count)}</div>
        </div>
      </div>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        {canUpdate && (
          <Button variant="primary" onClick={() => setShowUpdate(true)}>Update membership</Button>
        )}
        {canOverride && (
          <Button variant="link" className="membership-muted-link px-0" onClick={() => setShowOverride(true)}>
            Set membership count
          </Button>
        )}
      </div>
      <p className="text-muted small mb-0">
        Last updated: {asOf?.last_updated_at ? formatRecordedAt(asOf.last_updated_at) : 'Not updated yet'}
      </p>
      {canUpdate && (
        <UpdateMembershipModal
          show={showUpdate}
          apiPath={apiPath}
          onHide={() => setShowUpdate(false)}
          onSaved={() => setReloadKey((value) => value + 1)}
        />
      )}
      {canOverride && (
        <SetMembershipCountModal
          show={showOverride}
          apiPath={apiPath}
          onHide={() => setShowOverride(false)}
          onSaved={() => setReloadKey((value) => value + 1)}
        />
      )}
    </div>
  );
};

export default ChurchMembershipTab;
